const SvgNoAdsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={200} height={200} fill="none">
    <g filter="url(#a)">
      <rect width={200} height={200} fill="#29F085" rx={100} />
      <path
        fill="#fff"
        d="M36.466 71.2h15.28l20.48 56.8h-13.92l-3.68-10.64h-21.12l-3.6 10.64h-13.92l20.48-56.8Zm14.4 34.96-6.72-19.84-6.8 19.84h13.52ZM98.65 71.2c9.386 0 16.586 2.48 21.6 7.44 5.066 4.907 7.6 11.92 7.6 21.04 0 9.067-2.48 16.053-7.44 20.96-4.96 4.907-12.054 7.36-21.28 7.36h-20.72V71.2h20.24Zm0 45.28c5.12 0 8.906-1.36 11.36-4.08 2.453-2.773 3.68-7.04 3.68-12.8 0-5.76-1.227-10-3.68-12.72-2.454-2.773-6.24-4.16-11.36-4.16h-6.16v33.76h6.16Zm50.129-8.08c.32 1.92.96 3.573 1.92 4.96.96 1.333 2.24 2.373 3.84 3.12 1.6.693 3.466 1.04 5.6 1.04 1.6 0 2.986-.213 4.16-.64 1.226-.427 2.16-1.04 2.8-1.84.64-.8.96-1.787.96-2.96-.054-1.813-.907-3.28-2.56-4.4-1.654-1.12-4.507-2.16-8.56-3.12-6.987-1.6-12.267-3.787-15.84-6.56-3.52-2.773-5.28-6.4-5.28-10.88 0-3.467.933-6.48 2.8-9.04 1.866-2.613 4.48-4.613 7.84-6 3.413-1.44 7.386-2.16 11.92-2.16 4.266 0 8.053.827 11.36 2.48 3.36 1.6 6.026 3.893 8 6.88 2.026 2.933 3.28 6.373 3.76 10.32l-13.92.56c-.16-1.813-.667-3.387-1.52-4.72-.854-1.387-1.974-2.427-3.36-3.12-1.334-.693-2.88-1.04-4.64-1.04-2.454 0-4.427.56-5.92 1.68-1.494 1.12-2.16 2.587-2 4.4.053 1.227.506 2.267 1.359 3.12.854.8 1.921 1.467 3.201 2 1.28.48 2.986.987 5.12 1.52l.96.24c6.933 1.44 12.24 3.6 15.92 6.48 3.733 2.88 5.6 6.56 5.6 11.04 0 3.52-.96 6.587-2.88 9.2-1.92 2.613-4.587 4.613-8 6-3.414 1.333-7.28 2-11.6 2-4.747 0-8.96-.8-12.64-2.4-3.68-1.6-6.614-3.893-8.8-6.88-2.134-3.04-3.334-6.56-3.6-10.56l14-.72Z"
      />
      <g filter="url(#b)">
        <path
          fill="#fff"
          d="M8.63 144.67 183.517 43.699l5 8.66L13.63 153.33z"
        />
      </g>
    </g>
    <defs>
      <filter
        id="a"
        width={203}
        height={204}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={3} dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend in2="shape" result="effect1_innerShadow_3560_29754" />
      </filter>
      <filter
        id="b"
        width={187.887}
        height={117.631}
        x={4.63}
        y={43.699}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3560_29754"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_3560_29754"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgNoAdsIcon;
